
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/homemade-food-delivery",
      function () {
        return require("private-next-pages/homemade-food-delivery/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/homemade-food-delivery"])
      });
    }
  